export default __webpack_public_path__ + "static/media/solis.400d5dca.png";